import { setQzSecurityKeys } from '@dme/ticket-print';
import configs from '../config';

let qzKeysInitialized = false;
let qzKeysLoading = false;

async function loadKeyFromPath(filePath) {
  try {
    const response = await fetch(filePath);
    if (!response.ok) throw new Error();
    return await response.text();
  } catch {
    return '';
  }
}

export async function initializeQzKeys() {
  if (qzKeysInitialized || qzKeysLoading) return qzKeysInitialized;

  qzKeysLoading = true;

  try {
    const certificatePath = configs.QZ_ENC_CERTIFICATE_KEY;
    const privateKeyPath = configs.QZ_ENC_PRIVATE_KEY;

    if (!certificatePath || !privateKeyPath) return false;

    const [certificate, privateKey] = await Promise.all([
      loadKeyFromPath(`${process.env.PUBLIC_URL}/${certificatePath}`),
      loadKeyFromPath(`${process.env.PUBLIC_URL}/${privateKeyPath}`),
    ]);

    if (certificate && privateKey) {
      setQzSecurityKeys({ certificate, privateKey });
      qzKeysInitialized = true;
    }

    return qzKeysInitialized;
  } finally {
    qzKeysLoading = false;
  }
}

export function parseLogoDimensions(value) {
  const defaultWidth = 384;
  const defaultHeight = 200;

  if (!value) {
    return {
      maxLogoWidth: defaultWidth,
      maxLogoHeight: defaultHeight,
    };
  }

  const [width, height] = value
    .toLowerCase()
    .split('x')
    .map(Number);

  if (
    !Number.isFinite(width)
    || !Number.isFinite(height)
    || width <= 0
    || height <= 0
  ) {
    return {
      maxLogoWidth: defaultWidth,
      maxLogoHeight: defaultHeight,
    };
  }

  return {
    maxLogoWidth: width,
    maxLogoHeight: height,
  };
}

export function isQzInitialized() {
  return qzKeysInitialized;
}
